import React, { useState, useEffect, useRef } from "react";

import { NavLink } from "react-router-dom";
import logo from "../Assets/image 1.png";
import logo2 from "../Assets/image 2.png";


function Navbar() {
  const [isDivVisible, setIsDivVisible] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileRef = useRef(null);

  const toggleDivRef = useRef(null);
 const handleClickOutside = (event) => {
    if (toggleDivRef.current && !toggleDivRef.current.contains(event.target)) {
      setIsDivVisible(false);
    }
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsProfileOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <>
      <nav>
        <div className="navbar">
          <img src={logo} />
          <ul>
            <li>
              <NavLink className='name' exact activeClassName="active" to="/">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink  className='name' activeClassName="active" to="/about">
                About Us
              </NavLink>
            </li>
            <li>
              <NavLink  className='name' activeClassName="active" to="/services">
                Service
              </NavLink>
            </li>
            <li>
              <NavLink  className='name' activeClassName="active" to="/career">
                Career
              </NavLink>
            </li>
          </ul>
          <NavLink to='/contact'>

          <button>Contact Us</button>
          </NavLink>
          <i className="bi bi-list"
            onClick={() => setIsDivVisible(!isDivVisible)}
          ></i>
        </div>
      </nav>
        {isDivVisible && (
        <div className="toggleDiv-ops">
          <div className="toggleDiv" ref={toggleDivRef}>
            <ul>
             <li>
              <NavLink className='none' exact activeClassName="active" to="/">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink className='none' activeClassName="active" to="/about">
                About Us
              </NavLink>
            </li>
            <li>
              <NavLink className='none' activeClassName="active" to="/services">
                Service
              </NavLink>
            </li>
            <li>
              <NavLink className='none' activeClassName="active" to="/career">
                Career
              </NavLink>
            </li>
               <li>
              <NavLink className='none' activeClassName="active" to="/contact">
                Contact
              </NavLink>
            </li>
          <img src={logo2} />

            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;

